import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-314f07cc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "icon-wrapper" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-body" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Progress will "),
    /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "NOT"),
    /*#__PURE__*/_createTextVNode(" be saved."),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createElementVNode("span", { class: "strong" }, "NO POINTS"),
    /*#__PURE__*/_createTextVNode(" will be awarded. "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" What do you wish to do? ")
  ])
], -1))
const _hoisted_3 = { class: "controls-body" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" Cancel ")
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mx-2" }, "Exit", -1))

import ModalComponent from './ModalComponent.vue';
import ButtonComponent from './ButtonComponent.vue';
import IconComponent from './icon/IconComponent.vue';
import Icon from '@/components/icon/Icon';

export default /*#__PURE__*/_defineComponent({
  __name: 'ExitModalComponent',
  props: {
  modalActive: {
    type: Boolean,
    default: false
  }
},
  emits: ['toggle', 'reroute'],
  setup(__props) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ModalComponent, {
    onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('toggle'))),
    modalActive: __props.modalActive
  }, {
    body: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(IconComponent, {
          icon: _unref(Icon).ALERT_ORANGE
        }, null, 8, ["icon"])
      ]),
      _hoisted_2
    ]),
    navigation: _withCtx(() => [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(ButtonComponent, {
          class: "mr-2",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('toggle'))),
          "data-testid": "exit-button-no",
          "color-type": "primary",
          size: "medium"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }),
        _createVNode(ButtonComponent, {
          class: "ml-2",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('reroute'))),
          "data-testid": "exit-button-yes",
          "color-type": "tertiary",
          size: "medium"
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["modalActive"]))
}
}

})